import { CwsA, CwsHeaderNav, CwsHeaderNavItem } from '@components/cws'
import { usePreloadedInitialDataData } from '@context/PreloadedInitialDataContext'
import { keys } from 'ramda'
import React, { FC, useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'

interface UpperNavigationProps {
  isMobile?: boolean
}
export const UpperNavigation: FC<UpperNavigationProps> = ({ isMobile }) => {
  const [isRendered, setIsRendered] = useState(true)
  const { locale } = useRouter()
  const prevLocale = useRef<string | undefined>(locale)
  const items = usePreloadedInitialDataData().topNavigation
  const navItems = keys(items)

  useEffect(() => {
    if (prevLocale.current !== locale) {
      setIsRendered(false)
      prevLocale.current = locale
    } else {
      setIsRendered(true)
    }
  }, [locale, isRendered])

  const navigation = navItems.map((key, index, array) => {
    if (isMobile && key === 'Club One') return null
    return (
      <CwsHeaderNavItem
        divider={index === array.length - 1}
        current={items[key] === '/'}
        key={key}
        href={items[key]}
        label={key}
      >
        <CwsA target="_blank" hideArrow size="small" href={items[key]}>
          {key}
        </CwsA>
      </CwsHeaderNavItem>
    )
  })

  if (!isRendered) return null
  if (isMobile) {
    return <>{navigation}</>
  }
  return <CwsHeaderNav>{navigation}</CwsHeaderNav>
}
